import { Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CmsEmbeddedVideoComponent } from '../../../core/model';

@Component({
  selector: 'py-embedded-video',
  templateUrl: './embedded-video.component.html',
  styleUrls: ['./embedded-video.component.scss'],
  standalone: false,
})
export class EmbeddedVideoComponent implements OnInit {
  data: CmsEmbeddedVideoComponent;
  url$: Observable<string | undefined>;
  youtubeUrl: string = 'https://www.youtube.com/embed/';
  vimeoUrl = 'https://player.vimeo.com/video/';
  dreambrokerUrl = 'https://www.dreambroker.com/channel/';

  constructor(public component: CmsComponentData<CmsEmbeddedVideoComponent>) {}

  ngOnInit(): void {
    this.url$ = this.component.data$.pipe(
      map((data) => {
        const url = data?.url;
        if (!url) {
          return undefined;
        }

        let key = url;
        switch (data.videoOrigin) {
          case 'YOUTUBE':
            key = url
              .substr(url.lastIndexOf('/') + 1)
              .split('=')
              .pop();
            return this.youtubeUrl + key;
          case 'VIMEO':
            key = url.substr(url.lastIndexOf('/') + 1);
            return this.vimeoUrl + key;
          case 'DREAMBROKER':
            const key2 = url.split('/');
            key = url.substr(url.lastIndexOf('/') + 1);
            return this.dreambrokerUrl + key2[key2.length - 2] + '/iframe/' + key;
          default:
            return undefined;
        }
      })
    );
  }
}
